module.exports = __webpack_public_path__ + "static/media/nonord-c-16.8db261f4.mp3";